import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack5";
import { pdfjs } from "react-pdf";
import { Button } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { URL } from "../../constants/constant";
import "./PdfViewer.css";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import RotateRightIcon from '@mui/icons-material/RotateRight';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LAB_NAME } from '../../constants/constant';

export default function SinglePage(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [rotation, setRotation] = useState(0); // State for rotation angle

  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

  // let url = "https://report-digitisation.s3.amazonaws.com/Shaik37.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATTKKMOAPFUOL254U%2F20220512%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20220512T111006Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=f743a65c74a54546a97a3ad0702e9d624c9596d09de5e7512c8cada868f1b880"
  // let url = "https://d1e5wt947kkzyp.cloudfront.net/1100071566482_PATH.pdf"
  let { reportFileType, preSignedUrl, keyToDownload, testPage, setTestPage, labName } = props;
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    setPageNumber(testPage);
  }, [testPage]);

  function changePage(offset) {
    setTestPage((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const onSetScale = (type) => {
    let newScale = type ? scale + 0.5 : scale - 0.5;
    newScale = Math.min(Math.max(0.5, newScale), 10); // Clamp scale between 0.1 and 2
    setScale(newScale);
  };

  const rotateRight = () => {
    let newRotation = rotation + 90;
    if (newRotation >= 360) {
      newRotation -= 360;
    }
    setRotation(newRotation);
  };
  const rotateLeft = () => {
    let newRotation = rotation - 90;
    if (newRotation < 0) {
      newRotation += 360;
    }
    setRotation(newRotation);
  };
  async function handleDownload() {
    let urlToOpen = URL.mb_wapi + "getfile/" + keyToDownload;
    window.open(urlToOpen, "_blank", "noopener,noreferrer");
  }

  return (
    <>
      <div className="centered-pdf">
        <p>
          Page {pageNumber || (numPages ? pageNumber : "--")} of{" "}
          {numPages || "--"}
        </p>
        <div className="opt-btns">
          <ArrowBackIosIcon
            variant="outlined"
            style={{ fontSize: "1rem", scale: "1.6" }}
            disabled={pageNumber <= 1}
            className={pageNumber <= 1 ? "disabledButton " : ""}
            onClick={previousPage}
          />


          <NavigateNextIcon

            style={{
              scale: "1.6",
            }}
            variant="outlined"
            cursor="pointer"
            disabled={pageNumber >= numPages}
            className={pageNumber >= numPages ? "disabledButton" : ""}
            onClick={nextPage}
          />
          <DownloadIcon
            className="rightButton"
            variant="outlined"
            cursor="pointer"
            onClick={handleDownload}
            style={{
              scale: "1.6",
            }}
          />


          <ZoomInIcon style={{ cursor: "pointer", scale: "1.6" }} onClick={() => onSetScale(1)} />
          <ZoomOutIcon style={{ cursor: "pointer", scale: "1.6" }} onClick={() => onSetScale(0)} />
          <RotateLeftIcon
            variant="outlined"
            cursor="pointer"
            style={{
              scale: "1.6",
            }}
            onClick={rotateLeft}
          />
          <RotateRightIcon
            style={{
              scale: "1.6",
            }}
            variant="outlined"
            cursor="pointer"
            onClick={rotateRight}
          />


        </div>
        {reportFileType === 'application/pdf' ? (
          <div className="pdfWrapper">
            <Document

              file={preSignedUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(error) => console.log("Inside Error", error)}
            >
              <Page
                pageNumber={pageNumber}
                scale={scale}
                rotate={rotation}
                renderTextLayer={!LAB_NAME.some(name => 
                  name.trim().toLowerCase() === (labName || '').trim().toLowerCase()
              )}
              />
            </Document>
          </div>
        ) : (
          <div className="imageWrapper" style={{ overflow: 'auto', transform: ` rotate(${rotation}deg)` }}>
            <img
              style={{
                width: "100%",
                transform: `scale(${scale})`,

                transformOrigin: "top left",
              }}
              src={preSignedUrl} alt="Document" />
          </div>
        )}
      </div>
    </>
  );
}
